<script lang="ts">
	import Fa from 'svelte-fa';
	import { faX } from '@fortawesome/free-solid-svg-icons';
	interface Props {
		large?: boolean;
		onclick?: (event: MouseEvent) => void;
	}

	let { large = false, onclick }: Props = $props();
	let classBig = large ? 'btn-icon-lg' : '';
	// svelte-fa ^4 IconSize excludes empty string; use `undefined` for default size.
	const size: '1.5x' | undefined = large ? '1.5x' : undefined;
	let buttonClasses = ['btn-icon', 'bg-primary-500', 'text-white dark:text-white', classBig];
</script>

<button class={buttonClasses.join(' ')} {onclick} title="Dismiss">
	<Fa icon={faX} {size} />
</button>
